module.exports = __webpack_public_path__ + "media/images/roses/rose_red-7d2b33303b798fe04904b0949f4121f1.png";